(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('EndCustomerDialogController', EndCustomerDialogController);

    EndCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EndCustomer'];

    function EndCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EndCustomer) {
        var vm = this;

        vm.endCustomer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.endCustomer.id !== null) {
                EndCustomer.update(vm.endCustomer, onSaveSuccess, onSaveError);
            } else {
                EndCustomer.save(vm.endCustomer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:endCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfBirth = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
